<div class="ce-container">
  <div class="main-section">
    <div class="ce-card-title" data-test-id="header-ce-card">
      <h5>
        {{ 'broker.continuingEducation.header' | translate }}
      </h5>
    </div>
    <div class="section-separation">
      <div class="left-section right-border">
        <div class="left-section-content" data-test-id="left-section-education">
          {{ 'broker.continuingEducation.content' | translate }}
          <br />
          <br />
          <div class="course-catalog">
            <ul>
              <li>
                <span class="right-section-body">{{
                  'broker.continuingEducation.myCERSItems1' | translate
                }}</span>
              </li>
              <li>
                <span class="right-section-body">{{
                  'broker.continuingEducation.myCERSItems2' | translate
                }}</span>
              </li>
              <li>
                <span>{{
                  'broker.continuingEducation.myCERSItems3' | translate
                }}</span>
              </li>
              <li>
                <span class="right-section-body">{{
                  'broker.continuingEducation.myCERSItems4' | translate
                }}</span>
              </li>
              <li>
                <span class="right-section-body">{{
                  'broker.continuingEducation.myCERSItems5' | translate
                }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="button-container section-separation">
          <button
            class="explore-catalog"
            data-test-id="catalog-btn"
            cg-mat-btn-type="primary"
            [disabled]="isImpersonatorFlag"
            mat-raised-button
            (click)="exploreCatalog()"
          >
            {{ 'broker.continuingEducation.getStartedButton' | translate }}
            &nbsp;&nbsp;<cigna-icon
              type="external-link"
              class="cg-mat-icon-link-right cg-color-digital-blue setMargin"
            ></cigna-icon>
          </button>
        </div>
      </div>

      <div class="col-12 tab-section">
        <div class="button-container-tab section-separation">
          <button
            [disabled]="isImpersonatorFlag"
            class="explore-catalog"
            cg-mat-btn-type="primary"
            mat-raised-button
            (click)="exploreCatalog()"
          >
            {{ 'broker.continuingEducation.getStartedButton' | translate }}
            &nbsp;&nbsp;<cigna-icon
              type="external-link"
              class="cg-mat-icon-link-right cg-color-digital-blue setMargin"
            ></cigna-icon>
          </button>
        </div>
      </div>
      <br />

      <div class="note">
        <p data-test-id="course-footer-message">
          {{ 'broker.continuingEducation.myCERSfooter' | translate }}
        </p>
      </div>
    </div>
  </div>
</div>
